export * from "-!../../../../../../../node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!../../../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./CheckboxGroup.vue?vue&type=template&id=472e883a&"


//////////////////
// WEBPACK FOOTER
// ./src/modules/shared/ui/public/forms/fields/CheckboxGroup.vue?vue&type=template&id=472e883a&
// module id = 1109
// module chunks = 0